// extracted by mini-css-extract-plugin
module.exports = {"about":"styles_about__28ieU","llaimaLogo":"styles_llaimaLogo__DS27q","aboutText":"styles_aboutText__3MnQ3"};